import * as ActionTypes from './actionTypes';

const initialState = {
  createLoading: false,

  discoverPlaceList: { data: [], total: 0 },
  discoverPlaceListLoading: true,

  deleteLoading: false,

  discoverPlaceDetails: {},
  discoverPlaceDetailsLoading: true,

  updateLoading: false,
};

export default function discoverPlace(state = initialState, action) {
  switch (action.type) {
    // CREATE_DISCOVER_PLACE
    case ActionTypes.CREATE_DISCOVER_PLACE:
      return {
        ...state,
        createLoading: true,
      };

    case ActionTypes.CREATE_DISCOVER_PLACE_SUCCESS:
      return {
        ...state,
        createLoading: false,
      };

    case ActionTypes.CREATE_DISCOVER_PLACE_FAILED:
      return {
        ...state,
        createLoading: false,
      };

    // GET_DISCOVER_PLACE_LIST
    case ActionTypes.GET_DISCOVER_PLACE_LIST:
      return {
        ...state,
        discoverPlaceListLoading: true,
      };

    case ActionTypes.GET_DISCOVER_PLACE_LIST_SUCCESS:
      return {
        ...state,
        discoverPlaceListLoading: false,
        discoverPlaceList: action.payload,
      };

    case ActionTypes.GET_DISCOVER_PLACE_LIST_FAILED:
      return {
        ...state,
        discoverPlaceListLoading: false,
      };

    // CLEANUP_DISCOVER_PLACE_LIST
    case ActionTypes.CLEANUP_DISCOVER_PLACE_LIST:
      return {
        ...state,
        discoverPlaceListLoading: true,
        discoverPlaceList: { data: [], total: 0 },
      };
    // DELETE_DISCOVER_PLACE
    case ActionTypes.DELETE_DISCOVER_PLACE:
      return {
        ...state,
        deleteLoading: true,
      };

    case ActionTypes.DELETE_DISCOVER_PLACE_SUCCESS:
      return {
        ...state,
        discoverPlaceList: {
          ...state.discoverPlaceList,
          data: state.discoverPlaceList.data.filter((item) => item._id !== action.payload),
          total: state.discoverPlaceList.total - 1,
        },
        deleteLoading: false,
      };

    case ActionTypes.DELETE_DISCOVER_PLACE_FAILED:
      return {
        ...state,
        deleteLoading: false,
      };

    // GET_DISCOVER_PLACE_DETAILS
    case ActionTypes.GET_DISCOVER_PLACE_DETAILS:
      return {
        ...state,
        discoverPlaceDetailsLoading: true,
      };

    case ActionTypes.GET_DISCOVER_PLACE_DETAILS_SUCCESS:
      return {
        ...state,
        discoverPlaceDetailsLoading: false,
        discoverPlaceDetails: action.payload,
      };

    case ActionTypes.GET_DISCOVER_PLACE_DETAILS_FAILED:
      return {
        ...state,
        discoverPlaceDetailsLoading: false,
      };

    case ActionTypes.CLEANUP_DISCOVER_PLACE_DETAILS:
      return {
        ...state,
        discoverPlaceDetailsLoading: true,
        discoverPlaceDetails: {},
      };
    // UPDATE_DISCOVER_PLACE
    case ActionTypes.UPDATE_DISCOVER_PLACE:
      return {
        ...state,
        updateLoading: true,
      };
    case ActionTypes.UPDATE_DISCOVER_PLACE_SUCCESS:
      return {
        ...state,
        updateLoading: false,
      };
    case ActionTypes.UPDATE_DISCOVER_PLACE_FAILED:
      return {
        ...state,
        updateLoading: false,
      };

    default:
      return state;
  }
}
